<template>
    <div class="analysis-range" v-if="type == 1">
        <div class="progress-container">
            <div class="progress-bar" v-bind="$attrs">
                <span class="fixed-value b-600">{{max}}</span>
                <div class="progress-label" :style="{ 'right': 'calc(97% - ' + ratio + '%)' }">{{unitStart}}{{value}}{{unitEnd}}</div>
                <div class="progress" :style="{ 'width': ratio + '%' }"></div>
            </div>
        </div>
    </div>
    <div class="evaluation-range" v-else-if="type == 2">
        <div class="progress-container">
            <div class="progress-bar " v-bind="$attrs">
                <div class="progress" :style="{ 'width': ratio + '%' }">
                    <div class="progress-value" v-if="ratio >= 10">{{unitStart}}{{value}}{{unitEnd}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="productivity-range" v-else-if="type == 3">
        <div class="progress-container">
            <div class="progress-bar" v-bind="$attrs">
                <span class="fixed-value left">0</span>
                <div class="progress-value">{{unitStart}}{{value}}{{unitEnd}}</div>
                <div class="progress" :style="{ 'width': ratio + '%' }"></div>
                <span class="fixed-value right">{{ max }}</span>
            </div>
        </div>
    </div>
    <div class="weekly-progress" v-else-if="type == 4">
        <div class="progress-container">
            <div class="progress-bar" v-bind="$attrs">
                <div class="progress" :style="{ 'width': ratio + '%' }">
                    <div class="progress-value">{{unitStart}}{{value}}{{unitEnd}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { reactive, toRefs, computed } from 'vue';
    import { appData, C } from '@/helpers/global';

    export default {
        name: "ProgressBar",
        inheritAttrs: false,//,v-bind="$attrs"*/
        components: {
        },
        props: { 
            modelValue: {
                type: Number,
                required: true
            },
            type: {
                type: Number,
                required: true
            },
            max: {
                type: Number,
                default: 100
            },
            unitStart: {
                type: String,
                default: "%",
            },
            unitEnd: {
                type: String,
                default: "",
            }
        },
        emits: ["update:modelValue"],
        setup(props, ctx) {
            const e = reactive({
                value: computed({
                    get() {
                        return C.Dec(props.modelValue);
                    },
                    set(value) {                                             
                        ctx.emit("update:modelValue", value);
                    }
                }),
                ratio: computed(() => {
                    return (e.value * 100.00 / props.max);
                })
            });
            return { ...toRefs(e) };
        },
    };
</script>
